import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Pages/Home';
import About from './components/Pages/About';
import Market from './components/Pages/Market';
import Discover from './components/Pages/Discover';
import Activity from './components/Pages/Activity';

import Connect from './components/Connect/Connect';
import Profile from './components/Pages/User/Profile'
import Asset from './components/Pages/User/Asset/Asset'

import FullTopCollectors from './components/Pages/top/Collectors/FullTopCollectors'
import FullTopArtists from './components/Pages/top/Artists/FullTopArtists'
import FullLargestCollections from './components/Pages/top/LargestCollectors/FullLargestCollections'

import Create from './components/Pages/User/Pages/Create';
import OnSale from './components/Pages/User/Pages/OnSale'
import Created from './components/Pages/User/Pages/Created'
import Collections from './components/Pages/User/Pages/Collections'
import UserActivity from './components/Pages/User/Pages/UserActivity'
import Followers from './components/Pages/User/Pages/Followers'
import Settings from './components/Pages/User/Settings'

import Error from './components/Pages/Error/Error';
import Search from './components/Pages/search/Search';
import Support from './components/Pages/Support/Support';

function App() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/about" exact component={About} />
        <Route path="/market" exact component={Market} />
        <Route path="/activity" exact component={Activity} />
        <Route path="/discover" exact component={Discover} />
        <Route path="/search" exact component={Search} />
        <Route path="/support" exact component={Support} />

        <Route path="/connect" exact component={Connect} />
        <Route path="/create" exact component={Create} />
        <Route path="/user/username" exact component={Profile} />
        <Route path="/user/username/Asset" exact component={Asset} />

        <Route path="/top-collectors" exact component={ FullTopCollectors } />
        <Route path="/top-artists" exact component={ FullTopArtists } />
        <Route path="/largest-collections" exact component={ FullLargestCollections } />

        <Route path="/user/username/onsale" exact component={OnSale} />
        <Route path="/user/username/created" exact component={Created} />
        <Route path="/user/username/collections" exact component={Collections} />
        <Route path="/user/username/activity" exact component={UserActivity} />
        <Route path="/user/username/followers" exact component={Followers} />
        <Route path="/user/username/edit" exact component={Settings} />
        <Route path="*" component={Error} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
